import gsap from 'gsap';
import EventDispatcher from '../../common/EventDispatcher';
import { Global } from '../../common/global';

export default class Intro {
  constructor() {}
  init() {
    this.events = EventDispatcher.getObj();
    this.events.addEventListener('GAMESCENE_EVENTS', this.onEvents.bind(this));
  }
  onEvents(data) {
    switch (data['message']['event_type']) {
      case 'start_game':
        this.showIntro(data['message']['data']);
        break;
      case 'hide_intro':
        this.hideIntro(data['message']['data']);
        break;
    }
  }
  startGame() {
    document.querySelector('#intro_scr').classList.remove('active');
  }
  showAnimation() {
    this.frameDate = {
      value: 1,
    };
    document
      .querySelector('.swipe_intro .info2 .icon')
      .classList.remove(`hand${this.lastVal}`);
    this.lastVal = 0;
    gsap.killTweensOf(this.frameDate);
    this.introTwn = gsap.to(this.frameDate, {
      value: 83, // Animates from 10 to 0
      duration: 2, // 10 seconds
      ease: 'none',
      repeat: -1,
      delay: 0,
      onUpdate: function () {
        if (this.lastVal != Math.floor(this.frameDate.value)) {
          document
            .querySelector('.swipe_intro .info2 .icon')
            .classList.remove(`hand${this.lastVal}`);

          this.lastVal = Math.floor(this.frameDate.value);
          document
            .querySelector('.swipe_intro .info2 .icon')
            .classList.add(`hand${this.lastVal}`);
        }
      }.bind(this),
    });
  }
  showIntro(data) {
    // if (Global.introShown) return;

    Global.introShown = true;
    Global.introActive = true;
    document.querySelector('.swipe_intro').classList.add('active');
    document.querySelector('.swipe_intro').classList.add('active2');
    document.querySelector('.swipe_intro .icon').classList.add('active');

    this.showAnimation();

    //
  }
  hideIntro(data) {
    if (!Global.introActive) return;
    Global.introActive = false;
    gsap.killTweensOf(this.frameDate);
    document.querySelector('.swipe_intro').classList.remove('active');
    document.querySelector('.swipe_intro').classList.remove('active2');
    document.querySelector('.swipe_intro .icon').classList.remove('active');
  }
}
